import { Icon, IconNode } from "lucide-react";
import React from "react";

const TimesIconNode: IconNode = [
    [
        "path",
        {
            d: "M10.085 8L13.2122 4.87281C13.5959 4.48906 13.5959 3.86687 13.2122 3.48281L12.5172 2.78781C12.1334 2.40406 11.5113 2.40406 11.1272 2.78781L8 5.915L4.87281 2.78781C4.48906 2.40406 3.86688 2.40406 3.48281 2.78781L2.78781 3.48281C2.40406 3.86656 2.40406 4.48875 2.78781 4.87281L5.915 8L2.78781 11.1272C2.40406 11.5109 2.40406 12.1331 2.78781 12.5172L3.48281 13.2122C3.86656 13.5959 4.48906 13.5959 4.87281 13.2122L8 10.085L11.1272 13.2122C11.5109 13.5959 12.1334 13.5959 12.5172 13.2122L13.2122 12.5172C13.5959 12.1334 13.5959 11.5113 13.2122 11.1272L10.085 8Z",
            key: "times-icon-main",
        }
    ],
    [
        "path",
        {
            d: "M10.085 8L13.2122 4.87281C13.5959 4.48906 13.5959 3.86687 13.2122 3.48281L12.5172 2.78781C12.1334 2.40406 11.5113 2.40406 11.1272 2.78781L8 5.915L4.87281 2.78781C4.48906 2.40406 3.86688 2.40406 3.48281 2.78781L2.78781 3.48281C2.40406 3.86656 2.40406 4.48875 2.78781 4.87281L5.915 8L2.78781 11.1272C2.40406 11.5109 2.40406 12.1331 2.78781 12.5172L3.48281 13.2122C3.86656 13.5959 4.48906 13.5959 4.87281 13.2122L8 10.085L11.1272 13.2122C11.5109 13.5959 12.1334 13.5959 12.5172 13.2122L13.2122 12.5172C13.5959 12.1334 13.5959 11.5113 13.2122 11.1272L10.085 8Z",
            fill: "white",
            fillOpacity: "0.2",
            key: "times-icon-overlay"
        }
    ]
];

interface TimesIconProps {
    fill?: string;
    onClick?: () => void;
    className?: string;
}

export function TimesIcon({ fill = "currentColor", onClick, className }: TimesIconProps) {
    return (
        <Icon
            iconNode={TimesIconNode}
            size={16}
            viewBox="0 0 16 16"
            fill={fill}
            className={className}
            color="transparent"
            onClick={onClick}
            data-testid="times-icon"
        />
    );
}
